import { createContext, useContext, type ReactNode } from "react";
import { useDashboardConfigurator } from "../hooks/useDashboardConfigurator";
import { useEntityManagerContext } from "@/react/components/entityManager/context/EntityManagerContext";

type DashboardConfiguratorContextValue = ReturnType<
  typeof useDashboardConfigurator
>;

const DashboardConfiguratorContext =
  createContext<DashboardConfiguratorContextValue | null>(null);

export function DashboardConfiguratorProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { entityType } = useEntityManagerContext();
  const value = useDashboardConfigurator(entityType);

  return (
    <DashboardConfiguratorContext.Provider value={value}>
      {children}
    </DashboardConfiguratorContext.Provider>
  );
}

export function useConfiguratorContext() {
  const context = useContext(DashboardConfiguratorContext);
  if (!context) {
    throw new Error(
      "useConfiguratorContext must be used within DashboardConfiguratorProvider"
    );
  }
  return context;
}
